/**
 * @deprecated Use useDynamicsLeadCapture instead
 * This file is kept for backward compatibility but delegates to the new composable
 */

import {useDynamicsLeadCapture} from './useDynamicsLeadCapture'

// Flag to ensure ORing event listener is attached only once across components
let oringListenerAttached = false

export const usePartnerHubHelper = () => {
  const dynamics = useDynamicsLeadCapture()
  const {locale} = useI18n()

  const loadCRMFormCapture = (formId: string) => {
    dynamics.initializeFormCapture(formId, 'partnerHub', locale.value)
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error('Failed to load CRM form capture:', error)
      })
  }

  const getLanguageId = (localeCode: string) => {
    return dynamics.getLanguageId(localeCode)
  }

  const loadCRMFormCaptureORing = (formId: string) => {
    return new Promise((resolve, reject) => {
      dynamics.loadFormCaptureScript()
        .then(() => {
          if (oringListenerAttached) {
            resolve(undefined)
          } else {
            dynamics.setupFormCaptureListener(formId, 'oRing', locale.value)
              .then(() => {
                oringListenerAttached = true
                resolve(undefined)
              })
              .catch(error => {
                reject(error instanceof Error ? error : new Error(String(error)))
              })
          }
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          console.error('Failed to load CRM FormCapture script')
          reject(new Error('Failed to load CRM FormCapture script'))
        })
    })
  }

  const captureCRMDataORing = async (formData: any) => {
    try {
      await dynamics.captureFormData('oRing', formData, locale.value)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('CRM capture error:', error)
    }
  }

  return {
    loadCRMFormCapture,
    loadCRMFormCaptureORing,
    captureCRMDataORing,
    getLanguageId
  }
}
